import { FileAttachment, IAsset } from "./file-attachment.interface";

const KB_IN_BYTES = 1024;
const MB_IN_BYTES = KB_IN_BYTES * 1024;

export const getFileNameFromFileAttachment = (item: FileAttachment): string =>
  item.attachment?.split("?")[0]?.split("/").pop()!;

export const getFileExtensionFromFileAttachment = (item: FileAttachment): string =>
  getFileNameFromFileAttachment(item).split(".").pop()!;

export const getFileNameFromAssets = (item: IAsset): string =>
  item.url?.split("?")[0]?.split("/").pop()!;

export const getFileExtensionFromAssets = (item: IAsset): string =>
  getFileNameFromAssets(item).split(".").pop()!;

export function getFormattedFileSize(asset: IAsset): string {
  return formatSizeInBytes(asset.size);
}

function sizeInMb(sizeInBytes: number): number {
  return Math.round(sizeInBytes / MB_IN_BYTES);
}

function sizeInKb(sizeInBytes: number): number {
  return Math.round(sizeInBytes / KB_IN_BYTES);
}

function formatSizeInBytes(sizeInBytes: number): string {
  if (sizeInBytes >= MB_IN_BYTES) {
    return `${sizeInMb(sizeInBytes)} MB`;
  } else if (sizeInBytes >= KB_IN_BYTES) {
    return `${sizeInKb(sizeInBytes)} KB`;
  }
  return `${sizeInBytes} Bytes`;
}
